import { Link, NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';

const navItems = [
  { label: '首页', to: '/' },
  { label: '平台导航', to: '/directory' },
  { label: '论坛社区', to: '/forums' },
  { label: '发布指南', to: '/guide' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden md:block bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-content items-center justify-between px-6 py-2 text-xs">
          <p className="flex items-center gap-2">
            <span className="inline-flex h-1.5 w-1.5 rounded-full bg-accent-400 animate-soft-pulse"></span>
            目录已更新至 2026 年 9 月，本月新增 12 个可用发布入口
          </p>
          <p className="flex items-center gap-4 text-background-300">
            <span>本站为内容导航，不直接受理线索</span>
            <Link to="/guide" className="whitespace-nowrap text-accent-300 hover:text-accent-200 transition-colors cursor-pointer">
              先看投稿指南
            </Link>
          </p>
        </div>
      </div>

      <div
        className={`border-b transition-all duration-300 ${
          scrolled
            ? 'border-background-200 bg-background-50/95 backdrop-blur-md'
            : 'border-transparent bg-background-50'
        }`}
      >
        <div className="mx-auto flex max-w-content items-center gap-4 px-4 py-3 md:px-6 md:py-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label="爆料网上 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-megaphone-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">爆料网上</span>
              <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">BAOLIAO ONLINE</span>
            </span>
          </Link>

          <nav className="ml-2 hidden flex-1 items-center gap-1 lg:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors cursor-pointer ${
                    isActive
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 lg:ml-0">
            <Link
              to="/directory"
              className="hidden h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 sm:flex cursor-pointer"
              aria-label="搜索平台入口"
            >
              <i className="ri-search-line"></i>
            </Link>
            <Link
              to="/contact"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex cursor-pointer"
            >
              线索投稿
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((value) => !value)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 lg:hidden cursor-pointer"
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav className="mx-auto grid max-w-content grid-cols-2 gap-2 px-4 py-4" aria-label="移动端导航">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `whitespace-nowrap rounded-md px-3 py-2.5 text-sm transition-colors cursor-pointer ${
                      isActive
                        ? 'bg-primary-100 text-primary-700 font-medium'
                        : 'bg-background-100 text-foreground-700 hover:text-foreground-950'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                onClick={() => setMenuOpen(false)}
                className="col-span-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 cursor-pointer"
              >
                线索投稿
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}